import { Button, Col, Empty, Form, Input, Modal, Row, Spin, Tabs } from 'antd';
import { LoadingOutlined, SearchOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import * as SERVICE from '../../../constants/service.types';
import { useDispatch, useSelector } from 'react-redux';
import { generateLinkStorageFileReturn, socketEmitEvent, } from '../../../redux/actions';
import classes from './SearchVideosModal.module.scss';
import VideoPlayer from './VideoPlayer';
import VideoDescription from './VideoDescription';
import { useTranslation } from 'react-i18next';

const SearchVideosModal = ({ onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { listStorageFileByTag, namespace } = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(false);

  const [currentDateTab, setCurrentDateTab] = useState('all');
  const [recordDateGroups, setRecordDateGroups] = useState([]);

  useEffect(() => {
    setIsLoading(false);

    if (listStorageFileByTag) {
      const dateGroups = listStorageFileByTag.reduce((result, currentVideo) => {
        if (
          currentVideo.recordDate &&
          !result.find((item) => item.key === currentVideo.recordDate)
        ) {
          result.push({
            key: currentVideo.recordDate,
            title: currentVideo.recordDate,
          });
        }
        return result;
      }, []);

      setRecordDateGroups(dateGroups);
    }
  }, [listStorageFileByTag]);

  const handleSearchVideosByTag = ({ tag }) => {
    setIsLoading(true);
    dispatch(generateLinkStorageFileReturn(null));
    let dataObj = {
      appServiceType: SERVICE.LIST_STORAGE_FILE_BY_TAG,
      requestId: new Date().getTime(),
      body: JSON.stringify({
        tag,
        resource: 'storage_file',
        namespace,
      }),
    };
    dispatch(socketEmitEvent(dataObj));
  };

  const handleChangeTabDateGroup = (activeKey) => {
    dispatch(generateLinkStorageFileReturn(null));
    setCurrentDateTab(activeKey);
  };

  return (
    <Modal
      title={t('Search videos by tag')}
      centered
      visible
      onCancel={onClose}
      footer={null}
      width="85vw"
      bodyStyle={{ minHeight: '80vh' }}
    >
      <Form
        layout="inline"
        initialValues={{ tags: '' }}
        onFinish={handleSearchVideosByTag}
        autoComplete="off"
        className={classes['search-bar']}
      >
        <Form.Item
          label="Tag"
          name="tag"
          style={{ minWidth: 300 }}
          rules={[{ required: true, message: t('Please enter tag name') }]}
        >
          <Input placeholder={t('Tag name')} />
        </Form.Item>
        <Button htmlType="submit" icon={<SearchOutlined />} size="middle">
          {t('Search')}
        </Button>
      </Form>
      <div className={classes['videos-container']}>
        {isLoading && (
          <Spin indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />} />
        )}
        {!isLoading && listStorageFileByTag?.length > 0 && (
          <Tabs activeKey={currentDateTab} onChange={handleChangeTabDateGroup}>
            <Tabs.TabPane tab="All videos" key="all">
              {currentDateTab === 'all' && (
                <Row
                  gutter={[
                    { xs: 8, sm: 16, md: 24 },
                    { xs: 8, sm: 16, md: 24 },
                  ]}
                >
                  {listStorageFileByTag.map((video) => (
                    <Col key={video.recordId} xs={24} md={12} lg={8} xxl={6}>
                      <div className={classes['video-card']}>
                        <VideoPlayer video={video} />
                        <VideoDescription video={video} />
                      </div>
                    </Col>
                  ))}
                </Row>
              )}
            </Tabs.TabPane>
            {recordDateGroups.map((recordDateGroup) => (
              <Tabs.TabPane
                tab={recordDateGroup.title}
                key={recordDateGroup.key}
              >
                {currentDateTab === recordDateGroup.key && (
                  <Row
                    gutter={[
                      { xs: 8, sm: 16, md: 24 },
                      { xs: 8, sm: 16, md: 24 },
                    ]}
                  >
                    {listStorageFileByTag
                      .filter(
                        (video) => video.recordDate === recordDateGroup.key
                      )
                      .map((video) => (
                        <Col
                          key={video.recordId}
                          xs={24}
                          md={12}
                          lg={8}
                          xxl={6}
                        >
                          <div className={classes['video-card']}>
                            <VideoPlayer video={video} />
                            <VideoDescription video={video} />
                          </div>
                        </Col>
                      ))}
                  </Row>
                )}
              </Tabs.TabPane>
            ))}
          </Tabs>
        )}

        {!isLoading && listStorageFileByTag?.length === 0 && <Empty />}
      </div>
    </Modal>
  );
};

export default SearchVideosModal;
